import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {
  status: "",
  error: null,
  activeIndex: 0,
  onboardBtnEnable: false,
  nextBtnEnable: false,
  showOnboardBtn: false,
  isLeaveModal: false,
  showPrompt: false,

  statesarray: [],
  cityarray: [],
  entityLists: [],
  selectedServices: [],
  accessList: [],
  accesspaginationFirst: 0,
  accesspaginationRows: 10,

  isEditPersonelMode: false,
  isAddPersonelMode: false,

  personnelLists: [],
  serviceList: [],
  generaldata: {
    trading_name: "",
    start_date: null,
    end_date: null,
    phone: "",
    phone_code: "",
    email: "",
    hsp_manager_name: "",
    hsp_manager_email: "",
    account_manager_name: "",
    account_manager_email: "",
    account_manager_phone_code: "",
    account_manager_phone: "",
  },
  tradingdata: {
    country: "",
    address_line_1: "",
    address_line_2: "",
    state: "",
    city: "",
    postalcode: "",
  },
  lspdetails: null,
  lspList: null,
  lsplistpage: 0,
  lsplistlimit: 10,
};

export const LspCreation = createAsyncThunk(
  "lsponboarding/LspCreation",
  async (data) => {
    return await apiService(API_ROUTES.LSPONBOARDING, "POST", { body: data });
  },
);

export const getLspDetails = createAsyncThunk(
  "lsponboarding/getLspDetails",
  async (arg) => {
    const id = typeof arg === "object" ? arg.id : arg;
    const skipCache = typeof arg === "object" ? arg.skipCache : false;
    return await apiService(API_ROUTES.FETCH_LSP, "GET", {
      replace: { id },
      skipCache,
    });
  },
);
export const LspUpdatation = createAsyncThunk(
  // todo - improve semantics (lspUpdate, lspOnboarding)
  "lsponboarding/LspUpdatation",
  async (data) => {
    const id = data?.id;
    return await apiService(API_ROUTES.UPDATE_LSP, "PUT", {
      replace: { id },
      body: JSON.stringify(data),
    });
  },
);
export const fetchLsps = createAsyncThunk(
  "lsponboarding/fetchLsps",
  async (arg) => {
    const skipCache = typeof arg === "object" ? arg?.skipCache : false;
    const data = await apiService(API_ROUTES.FETCH_LSPS, "GET", { skipCache });
    return data;
  },
);

const lspOnboardSlice = createSlice({
  name: "lsponboarding",
  initialState,
  reducers: {
    setLspOnboarding: (state, { payload }) => {
      state[payload.key] = payload.value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LspCreation.pending, (state) => {
        state.status = "lsponboardloading";
      })
      .addCase(LspCreation.fulfilled, (state, { payload }) => {
        state.status = "lsponboardsucces";
        state.onboardeddata = payload.data;
        state.isLeaveModal = false;
        state.accessList = [];
        state.activeIndex = 0;
        state.tradingdata = {};
        state.isEdit = false;
      })
      .addCase(LspCreation.rejected, (state, action) => {
        state.status = "lsponboardfailed";
        state.error = action.error.message;
      })

      .addCase(fetchLsps.pending, (state) => {
        state.status = "lsplistloading";
        state.lspList = null;
      })
      .addCase(fetchLsps.fulfilled, (state, { payload }) => {
        state.status = "lsplistsucces";
        state.lspList = payload.data;
      })
      .addCase(fetchLsps.rejected, (state, action) => {
        state.status = "lsplistfailed";
        state.error = action.error.message;
      })

      .addCase(getLspDetails.pending, (state) => {
        state.status = "getlsploading";
        state.lspList = null;
      })
      .addCase(getLspDetails.fulfilled, (state, { payload }) => {
        state.status = "getlspsucces";
        state.lspdetails = payload.data;
      })
      .addCase(getLspDetails.rejected, (state, action) => {
        state.status = "getlspfailed";
        state.error = action.error.message;
      });
  },
});

export const { setLspOnboarding } = lspOnboardSlice.actions;
export default lspOnboardSlice.reducer;
